<div class="col-sm-12">
  <app-card [cardOptionBtnValue]="'global.edit'|translate"
            [cardOptionBtn]="true"
            [cardRouterLink]="'/back-office/fabric-collection/' + fabricCollection.id + '/edit'"
            [title]="'admin.fabric-collection.show.collection_information'|translate">
    <div class="row">
      <div class="col-sm-12 col-xl-3">
        <p class="text-muted m-b-10">{{'doctrine.fabric-collection.name'|translate}}</p>
        <label class="m-b-15">{{fabricCollection.name}}</label>
      </div>
      <div class="col-sm-12 col-xl-3">
        <p class="text-muted m-b-10">{{'doctrine.fabric-collection.dealer_price'|translate}}</p>
        <label class=" m-b-15">
          {{fabricCollection.dealerPrice| BackofficeCurrency:'EUR':'symbol-narrow':'4.2-2'}}
        </label>
      </div>
      <div class="col-sm-12 col-xl-3">
        <p class="text-muted m-b-10">{{'doctrine.fabric-collection.customer_price'|translate}}</p>
        <label class="m-b-15">
          {{fabricCollection.customerPrice| BackofficeCurrency:'EUR':'symbol-narrow':'4.2-2'}}
        </label>
      </div>
      <div class="col-sm-12 col-xl-3">
        <p class="text-muted m-b-10">{{'doctrine.fabric-collection.status'|translate}}</p>
        <label class="m-b-15">
          {{fabricCollection.status ? getFabricCollection().ACTIVE : getFabricCollection().INACTIVE}}</label>
      </div>
    </div>
  </app-card>
  <app-card *ngIf="fabricCollection.id"
    [cardOptionBtnValue]="'global.add_btn_text'|translate "
    [cardOptionBtnIcon]="'feather icon-plus'"
    [cardOptionBtn]="archive"
    [cardRouterLink]="'/back-office/fabric-collection/'+fabricCollection.id+'/fabric/add'"
    [title]="('admin.fabric-collection.show.fabrics'|translate) + ' (' + attachedFabrics + ')'">
    <div class="table-responsive" style="overflow-x:hidden; ">
      <table class="table table-hover">
        <thead>
        <tr>
          <th>{{'doctrine.fabric.name'|translate}}</th>
          <th>{{'doctrine.fabric.attached_colors'|translate}}</th>
          <th>{{'doctrine.fabric.dealer_price'|translate}}</th>
          <th>{{'doctrine.fabric.customer_price'|translate}}</th>
          <th>{{'doctrine.fabric.status'|translate}}</th>
          <th *ngIf="archive">{{'doctrine.fabric.position'|translate}}</th>
          <th class="text-end">{{'global.actions'|translate}}</th>
        </tr>
        </thead>
        <tbody>
        <tr *ngFor="let fabric of fabrics">
          <td>{{fabric.name}}</td>
          <td>{{(fabric.attachedColors)?fabric.attachedColors:0}}</td>
          <td>{{fabric.dealerPrice| BackofficeCurrency:'EUR':'symbol-narrow':'4.2-2'}}</td>
          <td>{{fabric.customerPrice| BackofficeCurrency:'EUR':'symbol-narrow':'4.2-2'}}</td>
          <td>{{fabric.status ? getFabrics().ACTIVE : getFabrics().INACTIVE}}</td>
          <td>
            <input *ngIf="archive" class="form-control" type="number" style="max-width:60px"
                   (blur)="setParentPosition(fabric.id,fabric.parentPosition)" name="position"
                   [(ngModel)]="fabric.parentPosition">
          </td>
          <td class="text-end">
            <span class="action-button">
              <a class="ripple light ms-2"
                   routerLink="/back-office/fabric-collection/{{fabricCollectionId}}/fabric/{{fabric.id}}/show" *ngIf="archive">
                <i class="fa fa-eye fa-lg"></i>
              </a>
            </span>
            <span class="action-button">
              <a class="ripple light ms-2"
                   routerLink="/back-office/fabric-collection/{{fabricCollectionId}}/fabric/{{fabric.id}}" *ngIf="archive">
                <i class="fa fa-pencil fa-lg"></i>
              </a>
            </span>
            <span class="action-button">
              <a class="ripple light ms-2"
                   (click)="setDetailForSoftDelete(fabric.id, fabric.name)"
                   *ngIf="archive">
                <i class="fa fa-remove fa-lg"></i>
              </a>
            </span>
            <span class="action-button">
              <a class="ripple light ms-2"
                   (click)="setDetailForReadd(fabric.id, fabric.name)"
                   *ngIf="!archive">
                <i class="feather icon-plus fa-lg"></i>
              </a>
            </span>
          <td>
        </tr>
        </tbody>
      </table>
    </div>
    <button class="btn btn-primary ripple light pull-right my-3" (click)="getFabricCollectionArchiveFabrics()"
            type="button" *ngIf="archive">{{'global.view_archive'|translate}}
    </button>
    <button class="btn btn-primary ripple light pull-right my-3" (click)="getFabricCollectionFabrics()" type="button"
            *ngIf="!archive">{{'doctrine.fabric.view_fabrics'|translate}}
    </button>
  </app-card>
</div>

<app-modal-basic #deleteModal>
  <div class="app-modal-header">
    <h4 class="modal-title">{{ 'global.soft_delete_title' | translate:{entity: 'Fabric'} }}</h4>
    <button type="button" class="close basic-close" (click)="deleteModal.hide()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="app-modal-body">
    <p>{{ 'global.soft_delete_body' | translate}}: <span [innerHTML]="fabricName"></span> ?</p>
  </div>
  <div class="app-modal-footer">
    <button type="button" class="btn btn-simple ripple me-4" (click)="deleteModal.hide()">{{'global.cancel'|translate}}
    </button>
    <button type="button" class="btn btn-primary ripple light" (click)="softDelete()">
      {{'global.actions.delete'|translate}}
    </button>
  </div>
</app-modal-basic>

<app-modal-basic #readdModal>
  <div class="app-modal-header">
    <h4 class="modal-title">{{ 'global.soft_readd_title' | translate:{entity: 'Fabric'} }}</h4>
    <button type="button" class="close basic-close" (click)="readdModal.hide()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="app-modal-body">
    <p>{{ 'global.soft_readd_body' | translate}}: <span [innerHTML]="fabricName"></span> ?</p>
  </div>
  <div class="app-modal-footer">
    <button type="button" class="btn btn-simple ripple me-4" (click)="readdModal.hide()">{{'global.cancel'|translate}}
    </button>
    <button type="button" class="btn btn-primary ripple light" (click)="readd()">{{'global.actions.readd'|translate}}
    </button>
  </div>
</app-modal-basic>
